import { variables } from '../variables';
import AvenirRoman from '../../fonts/GBIDirect/Avenir-Roman.woff2';
import AvenirBlack from '../../fonts/GBIDirect/Avenir-Black.woff2';

export const gbiDirectColors = {
  colorPrimary: '#035FF0',
  colorPrimaryLight: '#eef3fa',
  colorPrimaryDark: '#005aa5',
  colorProgressBarDefault: '#F4F4F4',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#FF5028',
  colorGrey: '#f4f4f4',

  // Button colors
  colorButtonPrimary: '#ffc015',
  colorButtonPrimaryInactive: 'rgba(235,160,0,0.7)',
  colorButtonPrimaryActive: '#ffc015',
  colorButtonSecoundary: '#F1F5F6', // don't use
  colorButtonSecondaryActive: '#E1E2E2F', // don't use

  // Icon
  colorCheckedIcon: 'green',

  // Text
  colorTextPrimary: '#69687e', // blue
  colorTextSecondary: '#353744', // semiDark
  colorTextOutline: '#14213D', // blueOutline
  colorTextLight: '#807F83', // light
  colorTextXLLight: '#69687e', // XL light
  colorTextGrey: '#69687e', // grey #8E8E8E
  colorTextGrey5: '#394A64', // grey 5
  colorTextGrey6: '#293854', // grey6
  colorTextError: '#FF0000', // red
  colorLink: '#035FF0', // semiDark

  // Backgrounds
  colorBackgroundPrimary: '#ffffff', // white
  colorBackgroundPrimaryDark: '#F7F7F7', // whitish
  colorBackgroundSecondary: '#fafafa', // xlGrey
  colorBackgroundSecondaryLight: '#F1F5F6', // light grey
  colorBackgroundSecondaryDark: '#16191D', // dark
  colorBackgroundSecondaryDark1: '#ECECEC', // dark1
  colorBackgroundDropzone: '#f9f9f9', // grey2
  colorBackgroundModal: 'rgba(0, 0, 0, 0.55)',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#C9D6DB', // grey
  colorBorderPrimaryDark: '#d8d8d8', // grey2
  colorBorderSecondary: '#EEA527', // yellow
  colorBorderSemiDark: 'rgba(78, 122, 140, 0.3)',
  colorsDivider: '#EDF2F3', // outline

  // svg colors
  colorSvgSemidark: '#006bc3',

  // Input
  colorInputBackground: '#006bc3',
  colorErrorMessage: '#FF5028',

  // Banner
  colorMisingInfoBackgorund: '#FFECB5',
  colorMissingInfoText: '#664D03',

  // Footer-Colors
  colorFooterBackground: '#035FF0', // #172029
  colorFooterText: '#fff', // #6e8fae
};

export const gbiDirectFonts = `
  @font-face {
    font-family: ${variables.family.gbiDirect}, sans-serif;
    src: url(${AvenirBlack}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: ${variables.family.gbiDirect}, sans-serif;
    src: url(${AvenirRoman}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  *,
  *::after,
  *::before {
    font-family: ${variables.family.gbiDirect}, sans-serif;
  }
`;
